import { makeStyles } from 'tss-react/mui';
import { CHAT_WIDTH } from '../../utils/chat.constants';

export const useChatConfigViewsStyles = makeStyles()((theme) => ({
  root: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: CHAT_WIDTH,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      border: 0,
      borderRadius: 0,
      overflowY: 'hidden',
    },
  },
}));
